import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import LoadingOverlay from "./loader/LoadingOverlay";

function AppContact() {
  const [headerLoading, setHeaderLoading] = useState(true);

  // Preload background image manually
  useEffect(() => {
    const headerImg = new Image();
    headerImg.src = require("../assets/images/contact5.png");
    headerImg.onload = () => setHeaderLoading(false);
    headerImg.onerror = () => setHeaderLoading(false);
  }, []);

  const onFormSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    const name = form.fullName.value.trim();
    const email = form.email.value.trim();
    const phone = form.phone.value.trim();
    const message = form.message.value.trim();

    if (!name || !message) {
      alert("Please enter both your name and message.");
      return;
    }

    const whatsappMessage = `Dear Kanchan Vidya Mandir School,\n\nMy name is ${name}.\n${message}\n\n${
      email ? `Email: ${email}\n` : ""
    }${phone ? `Phone: ${phone}` : ""}\n\nThank you!`;

    window.open(
      `https://wa.me/9899560650?text=${encodeURIComponent(whatsappMessage)}`,
    );
  };
  return (
    // <section id="contact" className="block contact-block bg-light text-dark py-5">
    <section id="contact" className="block contact-block">
      <div className="contact-page ">
        {/* HEADER */}
        <header className="mb-5 position-relative">
          {headerLoading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LoadingOverlay overlayOnly />
            </div>
          )}
          <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
            {/* <h1 className='text-center fw-semibold display-3'>Contact Us </h1> */}
            <h1 className="text-center fw-bold display-3 mb-3">Contact Us</h1>
            <p className="text-center w-75 fs-5">
              For any inquiries, admissions, or further information, please feel
              free to contact Kanchan Vidya Mandir Sr. Sec. School. Our team is
              always ready to assist you.
            </p>
          </div>
        </header>

        {/* Contact Form */}
        <Container className="mb-5 ">
          <Form id="contact-form" onSubmit={onFormSubmit}>
            <Row className="mb-3">
              <Col sm={4}>
                <Form.Control
                  name="fullName"
                  type="text"
                  placeholder="Enter your full name"
                  required
                />
              </Col>
              <Col sm={4}>
                <Form.Control
                  name="email"
                  type="email"
                  placeholder="Enter your email address"
                />
              </Col>
              <Col sm={4}>
                <Form.Control
                  name="phone"
                  type="tel"
                  placeholder="Enter your contact number"
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col sm={12}>
                <Form.Control
                  name="message"
                  as="textarea"
                  rows={4}
                  placeholder="Enter your message"
                  required
                />
              </Col>
            </Row>
            <div className="text-center">
              <Button type="submit" variant="primary" size="lg">
                Submit
              </Button>
            </div>
          </Form>
        </Container>
        {/* <div className='google-map'>
        <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14048.211570060965!2d-0.1228208876550775!3d51.505942908931324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2suk!4v1481805868782"></iframe>
      </div> */}
        {/* Contact Info */}
        <Container>
          <div className="contact-info text-center text-dark">
            <ul className="list-unstyled fs-5">
              <li>
                <i className="fas fa-envelope me-2 text-primary"></i>
                kanchanschool3370@gmail.com
              </li>
              <li>
                <i className="fas fa-phone me-2 text-primary"></i>+91
                9899560650, 7428046041
              </li>
              <li>
                <i className="fas fa-map-marker-alt me-2 text-primary"></i>
                Sector 56, Rajiv Colony, Ballabgarh, Faridabad, Haryana 121004
              </li>
            </ul>
          </div>
        </Container>
      </div>
    </section>
  );
}

export default AppContact;
